<template>
  <div class="verification">
    <section class="container" v-show="success && !loading">
      <img class="wave-top" src="@/assets/img/wave_top_page.png" />
      <img class="wave-top-mobile" src="@/assets/img/wave_top_mobile.png" />
      <h2>Verification Success</h2>
      <h3>Start Feeling the beat, Thank you for joining upmood</h3>
      <div class="image-wrapper  effect-move-up">
        <lottie
          :options="moodFeedOptions"
          v-on:animCreated="moodFeedAnimation"
        />
      </div>
      <div class="circle-light-yellow circle1 animate-growing"></div>
      <div class="circle-orange animate-growing"></div>
      <div class="circle-cyan animate-shrinking"></div>
      <div class="circle-light-yellow circle2 animate-shrinking"></div>
    </section>
    <section class="container" v-if="!success && !loading">
      <img class="wave-top" src="@/assets/img/wave_top_page.png" />
      <img class="wave-top-mobile" src="@/assets/img/wave_top_mobile.png" />
      <h2>Verification Failed</h2>
      <h3>Something went wrong.</h3>
      <div class="image-wrapper  effect-move-up">
        <img src="@/assets/img/alert.png" />
      </div>
    </section>
    <section class="container" v-if="loading">
      <img class="wave-top" src="@/assets/img/wave_top_page.png" />
      <img class="wave-top-mobile" src="@/assets/img/wave_top_mobile.png" />
      <h3>Verifying your email address.</h3>
      <br />
      <div class=" image-wrapper loading-wrapper">
        <span class="loading" v-if="loading"
          ><span class="load open"></span
        ></span>
      </div>
    </section>
  </div>
</template>

<script>
import Lottie from "@/components/Lottie";
import * as MoodFeed from "@/assets/animations/moodfeed/moodfeed.json";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      moodFeedOptions: {
        animationData: MoodFeed.default,
        loop: true,
        autoplay: false
      },
      success: false
    };
  },

  computed: {
    ...mapGetters({
      loading: "verify/getLoading",
      response: "verify/getResponse"
    })
  },

  async mounted() {
    //api for verify email
    let facebook_id = this.$route.query.facebook_id
      ? this.$route.query.facebook_id
      : "";
    let id = this.$route.query.id ? this.$route.query.id : "";
    let api = this.$route.query.api ? this.$route.query.api : "";
    await this.$store.dispatch("verify/verifyEmail", {
      url: `/web/authenticate/verifyEmail?facebook_id=${facebook_id}&id=${id}&api=${api}`
    });
    if (this.response) {
      if (this.response.data.status === 200) {
        this.success = true;
      } else {
        this.success = false;
      }
    }
  },

  activated() {
    this.moodFeedPlay();
  },

  deactivated() {
    this.moodFeedStop();
  },

  components: {
    lottie: Lottie
  },

  methods: {
    moodFeedAnimation(anim) {
      this.moodFeed = anim;
    },

    moodFeedStop() {
      this.moodFeed.stop();
    },

    moodFeedPlay() {
      this.moodFeed.play();
    }
  }
};
</script>

<style lang="scss" scoped>
.verification {
  section {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 200px;
    margin-top: 160px;
    position: relative;

    .wave-top {
      position: absolute;
      display: block;
      top: -240px;
      width: 100%;
      right: -325px;

      @include mobile {
        display: none;
      }
    }

    .wave-top-mobile {
      display: none;

      @include mobile {
        position: absolute;
        top: -200px;
        width: 115%;
        height: 100px;
        display: block;
      }
    }

    h2 {
      color: #4ecdb6;
      font-size: 60px;
      font-weight: bold;
      line-height: 75px;
      margin-bottom: 30px;
      text-align: center;
      font-family: $Quicksand;
      z-index: +1;

      @include mobile {
        font-size: 30px;
        line-height: 35px;
      }
    }

    h3 {
      color: $color2;
      font-size: 24px;
      line-height: 29px;
      margin-bottom: 60px;
      text-align: center;
      font-family: $Lato;
      z-index: +1;

      @include mobile {
        font-size: 20px;
      }
    }

    .image-wrapper {
      width: 250px;

      @include mobile {
        width: 150px;
      }
    }

    .circle-light-yellow {
      position: absolute;

      &.circle1 {
        height: 83px;
        width: 83px;
        top: -150px;
        left: 275px;

        @include mobile {
          height: 30px;
          width: 30px;
          top: -100px;
          left: 100px;
        }
      }

      &.circle2 {
        height: 499px;
        width: 499px;
        bottom: -500px;
        right: 0;

        @include mobile {
          width: 200px;
          height: 200px;
          bottom: -295px;
        }
      }
    }

    .circle-orange {
      height: 330px;
      width: 330px;
      position: absolute;
      left: -270px;
      top: 150px;

      @include mobile {
        height: 100px;
        width: 100px;
        left: -50px;
      }
    }

    .circle-cyan {
      position: absolute;
      height: 376px;
      width: 376px;
      right: -325px;
      top: -40px;

      @include mobile {
        height: 100px;
        width: 100px;
        right: -35px;
        top: 265px;
      }
    }
  }

  .loading-wrapper {
    margin-top: 100px;
    width: 100%;
  }

  .loading {
    width: 100px !important;
    height: 100px !important;
    display: flex !important;
    justify-content: center !important;
    position: absolute !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    color: #83dcca !important;

    .load {
      border: 20px solid #83dcca !important;
      width: 100px !important;
      height: 100px !important;
      position: absolute !important;
    }

    .open {
      border-top: 20px solid transparent !important;
    }
  }
}
</style>
